module.exports = __webpack_public_path__ + "static/media/HeroImage4.66ac7c65.svg";